
      window.addEventListener('load', function() {
        if (window.AdSpotter) {
          window.AdSpotter.init({
            buttonStyle: {
              text: 'Partner with Us',
              backgroundColor: '#4F46E5',
              textColor: '#FFFFFF',
              iconColor: '#FFFFFF',
              showIcon: true,
              position: 'bottom-right',
              fontSize: '0.875rem',
              padding: '0.75rem 1.25rem',
              borderRadius: '9999px'
            }
          });
        }
      });
    